import a from "../../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import f from "../../overlay/index.js";
import { context as i } from "./context.js";
import { mount as l } from "../../utils/functional.js";
import { removeNode as c } from "../../utils/dom/node.js";
var v = {
  className: "",
  customStyle: {}
};
function s(e) {
  return l(f, {
    on: {
      // close popup when overlay clicked & closeOnClickOverlay is true
      click: function click() {
        e.$emit("click-overlay"), e.closeOnClickOverlay && (e.onClickOverlay ? e.onClickOverlay() : e.close());
      }
    }
  });
}
function m(e) {
  var o = i.find(e);
  if (o) {
    var r = e.$el,
      n = o.config,
      t = o.overlay;
    r && r.parentNode && r.parentNode.insertBefore(t.$el, r), a(t, v, n, {
      show: !0
    });
  }
}
function k(e, o) {
  var r = i.find(e);
  if (r) r.config = o;else {
    var n = s(e);
    i.stack.push({
      vm: e,
      config: o,
      overlay: n
    });
  }
  m(e);
}
function C(e) {
  var o = i.find(e);
  o && (o.overlay.show = !1);
}
function N(e) {
  var o = i.find(e);
  o && (c(o.overlay.$el), i.remove(e));
}
export { C as closeOverlay, k as openOverlay, N as removeOverlay, m as updateOverlay };
